<template>
<div class="chapter">
<div class="inner_page">
<div class="chap" id="ded">
<p class="ct"><a class="xref" href="#/OEBPS/pppdesertshadows006#toc">Dedication</a></p>
<p class="ded"><i class="calibre4">For Paul, as always</i></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ppp-desertshadows004.vue?2a8a40ba